import { FunctionComponent, ReactNode } from 'react'
import { useScreenSize } from './screenSizeContext'

interface DesktopProps {
    children: ReactNode
}

const Desktop: FunctionComponent<DesktopProps> = ({ children }: DesktopProps) => {
    const isMobile: boolean = useScreenSize()
    return isMobile ? null : <>{children}</>
}

export default Desktop
